import Superior from './Superior';

export default Superior;